export default __webpack_public_path__ + "static/media/CLOCK.b8ed5130.svg";